
import { http } from "Utils/http";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import 'react-phone-input-2/lib/style.css'
import { setGlobalErrorStatus } from 'Components/StatusHandling';
import { useDispatch } from "react-redux"
import 'react-phone-input-2';
import { store } from 'Store';
import { ERROR_MESSAGES, ROLES } from "Utils/constants";
import ProfileActivityTable from "./PSOProfileActivity/ProfileActivityTable";
import { Form, Tabs, Tab, Row, Col, Card } from "react-bootstrap";
import DataSubmissionActivityTable from "./DataSubmissionActivity/DataSubmissionActivityTable";
import PSOCFSubmissionSummaryTable from "./PSOCFSubmissionSummary/PSOCFSubmissionSummaryTable";
import PSOProfileSubmissionCurrentTable from "./PSOProfileSubmissionCurrent/PSOProfileSubmissionCurrentTable";
import UserActivityTable from "./UserActivity/UserActivityTable";
import OrganizationSummaryTable from "./OrganizationSummary/OrganizationSummaryTable";
import UpcomingEvents from "./UpcomingEvents/UpcomingEvents";


function Dashboard () {
    let location = useLocation();
    var passedData = location.state;

    const dispatch = useDispatch();
    const [userRole, setUserRole] = useState(null);
    const [isVendor, setIsVendor] = useState(null);
    const [isPSO, setIsPSO] = useState(null);
    const [showEvents, setShowEvents] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    //console.log(location); 

    const handleGetRole = async (e) => {
        var url = '/api/dashboard/';

        const loginState = store.getState().loginInfo;
        //console.log(loginState);
        const res = http.post(url, null, {
            timeout: 65000, // Set a timeout of 5 seconds,
            headers: {
                "Authorization": "Bearer " + loginState.token
            }
        }).then((response) => {
            //console.log(response);
            if (response != null) {
                var statusCode = response.status;
                if (statusCode != 1) {
                    setGlobalErrorStatus({
                        dispatch: dispatch,
                        popupData: {
                            visible: true,
                            title: ERROR_MESSAGES.GENERAL_ERROR.title,
                            msg: response.globalErrorMessageList != null && response.globalErrorMessageList.length > 0 ? response.globalErrorMessageList : ERROR_MESSAGES.GENERAL_ERROR.message,
                            showContactHelp: false
                        },
                        redirect: {
                            redirect: false,
                            redirectFirst: false,
                            path: "",
                            data: {}
                        }
                    });
                }
                else {
                    setUserRole(response.data.roleName);
                    setIsVendor(response.data.isVendor);
                    setIsPSO(response.data.isPSO);
                    setShowEvents(response.data.showEvents);
                }
            }
            else {
                setGlobalErrorStatus({
                    dispatch: dispatch,
                    popupData: {
                        visible: true,
                        title: ERROR_MESSAGES.GENERAL_ERROR.title,
                        msg: ERROR_MESSAGES.GENERAL_ERROR.message,
                        showContactHelp: true
                    },
                    redirect: {
                        redirect: false,
                        redirectFirst: false,
                        path: "",
                        data: {}
                    }
                });
            }
            setIsLoading(false);
        }).catch(function (error) {
            //console.log(error);
            setGlobalErrorStatus({
                dispatch: dispatch,
                popupData: {
                    visible: true,
                    title: ERROR_MESSAGES.GENERAL_ERROR.title,
                    msg: ERROR_MESSAGES.GENERAL_ERROR.message,
                    showContactHelp: true
                },
                redirect: {
                    redirect: false,
                    redirectFirst: false,
                    path: "",
                    data: {}
                },
                error: error
            });
        });
        return res;
    };

    const [dataSubTab, setDataSubTab] = useState("CDA");


    const handleDataSubTabChange = (e) => {
        //console.log(e);
        setDataSubTab(e);
    }

    useEffect(() => {

        handleGetRole();
        if (passedData != null && passedData.hasOwnProperty("tab")) {
            setDataSubTab(passedData.tab);
        }
    }, [])

    const ROLE_ACCESS = {
        UsersButton: [
            ROLES.PSOA.id
        ],
        Events: [
            ROLES.PSOA.id,
            ROLES.PPCA.id,
            ROLES.PPCM.id,
            ROLES.L1.id,
            ROLES.L2.id,
            ROLES.L3.id,
            ROLES.AUSER.id,
            ROLES.AM.id
        ],
        PSOProfileActivity: [
            ROLES.PSOA.id,
            ROLES.L2.id,
            ROLES.L3.id
        ],
        OrganizationSummary: [
            ROLES.PPCA.id,
            ROLES.PPCM.id,
            ROLES.AM.id
        ],
        UserActivity: [
            ROLES.PPCA.id
        ],
        DataSubmissionActivity: [
            ROLES.PSOA.id,
            ROLES.PPCA.id,
            ROLES.L3.id
        ],
        PSOCFSubmissionSummary: [
            ROLES.PPCA.id,
            ROLES.PPCM.id,
            ROLES.AM.id
        ],
        PSOProfileSubmissionCurrentYear: [
            ROLES.PPCM.id,
            ROLES.AM.id
        ]
    }

    const checkAccess = (itemName) => {
        if (ROLE_ACCESS.hasOwnProperty(itemName)) {
            var x = ROLE_ACCESS[itemName];
            if (x.includes(userRole)) {
                return true;
            }
        }
        return false;
    }

    return (
        userRole != null && isLoading == false
            ?
            <Row className="">
                <Col xl={11} lg={11} md={11} sm={12}>
                    <Card className="p-4" >
                        <Card.Body className="text-start">
                            <Row>
                                <h1 id="mainContent" className="header1 text-start mb-3 blue bold">Dashboard</h1>
                            </Row>
                            <Row>
                                <Form>

                                    {
                                        //userRole == ROLES.PSOA.id || userRole == ROLES.PPCA.id || userRole == ROLES.AM.id || userRole == ROLES.L2.id || userRole == ROLES.L1.id || userRole == ROLES.AUSER.id || userRole == ROLES.L3.id || userRole == ROLES.PPCM.id
                                        checkAccess('Events') && showEvents == true
                                            ?

                                            <>
                                                <h2>Upcoming Events</h2>
                                                <UpcomingEvents></UpcomingEvents>

                                            </>
                                            : null
                                    }

                                    {
                                        //userRole === ROLES.PSOA.id || userRole == ROLES.L2.id
                                        checkAccess('PSOProfileActivity') && isPSO == true
                                            ?
                                            <div className="mb-5">
                                                <h2>PSO Profile Activity</h2>
                                                <ProfileActivityTable></ProfileActivityTable>
                                            </div>
                                            : null
                                    }

                                    {
                                        //userRole === ROLES.PPCA.id || userRole == ROLES.AM.id
                                        checkAccess('OrganizationSummary')
                                            ?
                                            <>
                                                <h2>Organization Summary</h2>
                                                <OrganizationSummaryTable></OrganizationSummaryTable>
                                            </>

                                            : null
                                    }

                                    {
                                        //userRole === ROLES.PPCA.id
                                        checkAccess('UserActivity')
                                            ?
                                            <div>
                                                <h2>User Activity</h2>
                                                <UserActivityTable></UserActivityTable>
                                            </div>

                                            : null
                                    }

                                    {
                                        //userRole == ROLES.PSOA.id || userRole == ROLES.PPCA.id || userRole == ROLES.L3.id
                                        checkAccess('DataSubmissionActivity')
                                            ? <Row>
                                                <Col>
                                                    <h2>Data Submission Activity</h2>
                                                    <Tabs
                                                        id="dataSubTabs"
                                                        activeKey={dataSubTab}
                                                        onSelect={(k) => handleDataSubTabChange(k)}
                                                        mountOnEnter={true}
                                                        unmountOnExit={true}
                                                    >
                                                        <Tab eventKey="CDA" title="CDA Data Submission" >
                                                            {dataSubTab === "CDA"
                                                                ?
                                                                <DataSubmissionActivityTable submissionFormat={1} submissionState={1} role={userRole} isVendor={isVendor}></DataSubmissionActivityTable>
                                                                : null
                                                            }
                                                        </Tab>
                                                        <Tab eventKey="Alt" title="Alternate Data Submission" >
                                                            {
                                                                dataSubTab === "Alt"
                                                                    ?
                                                                    <DataSubmissionActivityTable submissionFormat={0} submissionState={1} role={userRole} isVendor={isVendor}></DataSubmissionActivityTable>
                                                                    : null
                                                            }
                                                        </Tab>

                                                    </Tabs>

                                                </Col>

                                            </Row>
                                            : null
                                    }

                                    {
                                        //userRole == ROLES.PPCA.id || userRole == ROLES.AM.id || userRole == ROLES.PPCM.id
                                        checkAccess('PSOCFSubmissionSummary')
                                            ?
                                            <>
                                                <h2>PSO Common Formats Submission Summary</h2>
                                                <PSOCFSubmissionSummaryTable></PSOCFSubmissionSummaryTable>
                                            </>
                                            : null
                                    }
                                    {
                                        //userRole == ROLES.AM.id || userRole == ROLES.PPCM.id
                                        checkAccess('PSOProfileSubmissionCurrentYear')
                                            ?
                                            <>
                                                <h2>PSO Profile Submission in Current Reporting Year</h2>
                                                <PSOProfileSubmissionCurrentTable></PSOProfileSubmissionCurrentTable>
                                            </>
                                            : null
                                    }

                                </Form>

                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            : null

    );
}


export default Dashboard;
